import React from "react";

const Clock = ({ color = "#1E84BE" }) => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9993 7.33366C13.8992 7.33366 7.33268 13.9001 7.33268 22.0003C7.33268 30.1005 13.8992 36.667 21.9993 36.667C30.0995 36.667 36.666 30.1005 36.666 22.0003C36.666 13.9001 30.0995 7.33366 21.9993 7.33366ZM3.66602 22.0003C3.66602 11.8751 11.8741 3.66699 21.9993 3.66699C32.1246 3.66699 40.3327 11.8751 40.3327 22.0003C40.3327 32.1255 32.1246 40.3337 21.9993 40.3337C11.8741 40.3337 3.66602 32.1255 3.66602 22.0003ZM21.9993 11.0003C23.0119 11.0003 23.8327 11.8211 23.8327 12.8337V21.2409L28.7957 26.204C29.5117 26.9199 29.5117 28.0807 28.7957 28.7967C28.0797 29.5127 26.9189 29.5127 26.203 28.7967L20.703 23.2967C20.3592 22.9529 20.166 22.4866 20.166 22.0003V12.8337C20.166 11.8211 20.9868 11.0003 21.9993 11.0003Z"
        fill={color}
      />
    </svg>
  );
};

export default Clock;
